import { FC } from 'react';
import { CreateOfflineSupplierFormValues } from 'src/types/manage-suppliers/CreateOfflineSupplierForm';
import {
  SupplierFormBaseFieldKey,
  SupplierRequiredFields,
  SupplierTransmissionType,
} from 'src/types/manage-suppliers/SupplierForm';
import SupplierForm from './SupplierForm';
import { CREATE_SUPPLIER_FIELD_ACCESS, fromCreateFormValues } from './utils/supplierFormValues';

interface CreateOfflineSupplierFormProps {
  values: CreateOfflineSupplierFormValues;
  errors: Partial<Record<SupplierFormBaseFieldKey, string>>;
  touched: Partial<Record<SupplierFormBaseFieldKey, boolean>>;
  requiredFields?: SupplierRequiredFields;
  onFieldChange: (
    field: SupplierFormBaseFieldKey,
    value: string | SupplierTransmissionType
  ) => void;
  onFieldBlur: (field: SupplierFormBaseFieldKey) => void;
}

const CreateOfflineSupplierForm: FC<CreateOfflineSupplierFormProps> = ({
  values,
  errors,
  touched,
  requiredFields,
  onFieldChange,
  onFieldBlur,
}) => (
  <SupplierForm
    mode="create"
    hasActionBar
    values={fromCreateFormValues(values)}
    errors={errors}
    touched={touched}
    fieldAccess={CREATE_SUPPLIER_FIELD_ACCESS}
    requiredFields={requiredFields}
    onFieldChange={(field, value) => {
      if (field === 'status') {
        return;
      }
      onFieldChange(field, value);
    }}
    onFieldBlur={(field) => {
      if (field === 'status') {
        return;
      }
      onFieldBlur(field);
    }}
  />
);

export default CreateOfflineSupplierForm;
